export const ASSETS_PATH = "https://sumerlabs.com/prod";